import React, { FC } from "react";
import { Descriptions, Divider } from "antd";
import { useAppSelector } from "../../../store/reduxHooks";
import { SELECT_PROFILE_DATA } from "../../../store/selectors/profileSelectors";

export const ProfileInfo: FC = () => {
  const selectProfile = useAppSelector(SELECT_PROFILE_DATA);

  return (
    <div>
      <Divider orientationMargin={0} orientation="left">
        <h3>Личная информация</h3>
      </Divider>
      <Descriptions>
        <Descriptions.Item label={"ФИО"}>
          {selectProfile?.surname} {selectProfile?.name}{" "}
          {selectProfile?.patronymic}
        </Descriptions.Item>
      </Descriptions>
      {(selectProfile?.organization || selectProfile.inn) && (
        <Descriptions>
          <Descriptions.Item label={"ИНН"}>
            {selectProfile?.organization
              ? selectProfile.organization.inn
              : selectProfile.inn}
          </Descriptions.Item>
        </Descriptions>
      )}
      {selectProfile?.organization && (
        <>
          <Descriptions>
            <Descriptions.Item label={"ОГРН"}>
              {selectProfile?.organization.ogrn}
            </Descriptions.Item>
          </Descriptions>
          <Descriptions>
            <Descriptions.Item label={"Наименование организации"}>
              {selectProfile?.organization.name}
            </Descriptions.Item>
          </Descriptions>
        </>
      )}
      <Descriptions>
        <Descriptions.Item label={"Почтовый адрес"}>
          {selectProfile?.email}
        </Descriptions.Item>
      </Descriptions>
    </div>
  );
};
